import { useSyncExternalStore } from 'react';

const query =
  typeof window !== 'undefined' ? window.matchMedia('(display-mode: standalone)') : null;

function subscribe(callback: () => void): () => void {
  if (!query) return () => {};
  query.addEventListener('change', callback);
  return () => query.removeEventListener('change', callback);
}

function getSnapshot(): boolean {
  if (typeof window === 'undefined') return false;

  const mediaMatch = query?.matches ?? false;
  const navigatorStandalone =
    'standalone' in navigator &&
    Boolean((navigator as Navigator & { standalone?: boolean }).standalone);

  return mediaMatch || navigatorStandalone;
}

function getServerSnapshot(): boolean {
  return false;
}

export function useIsPwa(): boolean {
  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}
